module.exports = __webpack_public_path__ + "static/project-5-1-3964e6b8d54d0274dae6cc02040c5e5b.jpg";